import TableRow from "../../../../components/table/components/table-row/table-row";
import LocaleContainer from "../locale-container/locale-container";
import { observer } from "mobx-react";
import { Toggle } from "../../../../components/inputs/toggle/toggle";
import SelectDefaultlocale from "../select-defult-locale/select-default-locale";
import LocaleStore from "../../stores/locale-store";
import DeleteLocaleButton from "../delete-locale-button/delete-locale-button";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import { useState } from "react";
import LocaleStatusChip from './locale-status-chip';
import { LocaleStatus } from "../../../../services/api/locales-service";
import { Tooltip } from "../../../../components/tooltip/tooltip";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";

interface ILocaleItemProps {
    locale: LocaleStore;
}

const LocaleTableRaw: React.FC<ILocaleItemProps> = observer(({ locale }) => {
    const [showDeleteModal, setShowDeleteModal] = useState<boolean> (false);

    const hasMissingTranslations = locale.localeStatus === LocaleStatus.NO_TRANSLATIONS;

    const LanguageToggle = <Toggle 
        disabled={locale.is_default || hasMissingTranslations} 
        checked={locale.enabled}
        label="" 
        onChange={() => locale.toggleEnabled()}
    />

    return (
        <>
            <TableRow
                cells={[
                    <LocaleContainer localeName = {locale.localeName} isNewLocale = {locale.isNewLocale()}/>,
                    hasMissingTranslations
                        ?   <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_1_WHITE}>{"Complete all missing translations to enable this language"}</FontBody2>}>
                                {LanguageToggle}
                            </Tooltip>
                        :   LanguageToggle,
                    <LocaleStatusChip locale={locale} />,
                    <SelectDefaultlocale locale={locale}/>,
                    <DeleteLocaleButton onClick={() => setShowDeleteModal(true)} isDisabled={locale.is_default} />,
                ]}
            />
            { showDeleteModal &&
                <ConfirmModal 
                title={"Delete Language"}
                text={<>You asked to delete the language <strong>{locale.localeName}</strong></>}
                implicationText={<>Note: this action will delete all the translations and it's <strong> irreversible!</strong></>}
                questionText={"Are you sure you want to delete this language?"}
                cancelButton={{ 
                    title: "Cancel", 
                    onClick: () => setShowDeleteModal(false)} 
                } 
                okButton={{ 
                    title: "Delete", 
                    onClick: () => {
                        locale.handleDelete();
                        setShowDeleteModal(false);
                    }
                }} />
            }
            </>
    );
});

export default LocaleTableRaw;
